import * as React from 'react'
import PropTypes from 'prop-types'
import { withStatus } from '../modules/status'
import './spinner.css'


@withStatus
export default class extends React.Component<any, any>{

    render(){
        return (
            <div className={`spinner ${this.props.status.loading ? "" : "hidden-xs-up"}`}>
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw fa-2x"></i>
                    <span className="sr-only">Loading...</span>
                </div>
            )
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/spinner.tsx